import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Breadcrumb } from '@nk/core/services/navigation.utils';

@Component({
  selector: 'nk-sub-navigation-breadcrumb',
  templateUrl: './sub-navigation-breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubNavigationBreadcrumbComponent implements OnInit {
  @Input() public breadcrumbs: Breadcrumb[];

  public ngOnInit(): void {
    if (this.breadcrumbs) {
      this.breadcrumbs = this.breadcrumbs.filter((a) => a.data).filter((a) => a.data['title']);
    }
  }
}
